
import React, { useState } from "react";
import Webcam from "react-webcam";
import _ from "lodash";
import "react-html5-camera-photo/build/css/index.css";
import srcIconPhoto from "../../../../../styles/img/icon-photo.svg";
import srcIconVideoSwitch from "../../../../../styles/img/icon-video-switch.svg";
const IconVideoSwitch = () => (
  <object
    data={srcIconVideoSwitch}
    type="image/svg+xml"
    style={{
      width: "40px",
      height: "40px",
      pointerEvents: "none",
      cursor: "pointer",
    }}
    className="img-fluid"
  />
);
const IconPhoto = () => (
  <object
    data={srcIconPhoto}
    type="image/svg+xml"
    style={{
      width: "40px",
      height: "40px",
      pointerEvents: "none",
      cursor: "pointer",
      color: "#fffff"
    }}
    className="img-fluid"
  />
);
const IcrecheCamera = (props) => {
  const webcamRef = React.useRef(null);

  const [videoConstraints, setVideoConstraints] = useState({
    width: 1280,
    height: 720,
    facingMode: "user",
  });

  const capture = React.useCallback(
    () => {

      const imageSrc = webcamRef.current.getScreenshot();
      let base64Image = imageSrc.split(";base64,").pop();
      const blob = b64toBlob(base64Image, "image/png");
      props.goToCorpImageTab(blob);
    },
    [webcamRef]
  );


  const b64toBlob = (b64Data, contentType = "", sliceSize = 512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  };

  return (
    <>
      <div >
        <div>
          <Webcam
            audio={false}
            height="auto"
            ref={webcamRef}
            screenshotFormat="image/jpeg"
            width="100%"
            videoConstraints={videoConstraints}
          />
        </div>
        <div
          className="d-flex align-items-center justify-content-center"
          style={{
            paddingTop: "20px",
            display: "flex",
            flexDirection: "row",
            justifyContent: "between",
            marginTop: "-20px",
          }}
        >
          <button classeName="btn-gradient"
            style={{
              borderRadius: "50%",
              width: "60px",
              height: "60px",
              background: "linear-gradient(135deg, #ffc061 0%,#ff4f68 100%)"
            }}
            onClick={() => {
              if (videoConstraints.facingMode === "user") {
                const frontCamera = {
                  width: 1280,
                  height: 720,
                  facingMode: { exact: "environment" },
                };
                setVideoConstraints(frontCamera);
              } else {
                const backCamera = {
                  width: 1280,
                  height: 720,
                  facingMode: "user",
                };
                setVideoConstraints(backCamera);
              }
            }}
          >
            <IconVideoSwitch />
          </button>
          <button
            classeName="btn-photo btn-gradient d-flex align-items-center justify-content-center bg-dark"
            style={{
              borderRadius: "50%",
              width: "60px",
              height: "60px",
              background: "linear-gradient(135deg, #ffc061 0%,#ff4f68 100%)",
              marginLeft: "20px"
            }}
            onClick={capture}
          >
            <IconPhoto />
          </button>
        </div>
      </div>
    </>
  );
};

export default IcrecheCamera;


